export const safeParseJson = (value, fallback = null) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
};

export const safeStringifyJson = (value, fallback = "") => {
  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return fallback;
  }
};
